'use client'

import { useEffect, useState } from 'react'

export default function DevHelperTypescale() {
	const [windowWidth, setWindowWidth] = useState<number>(0)
	const [typeHelperOn, setTypeHelperOn] = useState(false)

	useEffect(() => {
		function listenForShortcut(event: KeyboardEvent) {
			if (event.code == 'KeyT' && event.altKey) {
				if (typeHelperOn) {
					setTypeHelperOn(false)
				} else {
					setTypeHelperOn(true)
				}
			}
		}
		window.addEventListener('keyup', listenForShortcut, false)
		return () => window.removeEventListener('keyup', listenForShortcut, false)
	}, [typeHelperOn])

	useEffect(() => {
		function updateComputerFontSizes() {
			document!.querySelectorAll('.show-computed-size').forEach((el) => {
				let fontSize: number = parseFloat(window.getComputedStyle(el, null).getPropertyValue('font-size'))
				fontSize = Math.round(fontSize)
				el.innerHTML = `${fontSize}px`
			})
			setWindowWidth(window.innerWidth)
		}
		updateComputerFontSizes()
		window.addEventListener('resize', updateComputerFontSizes)

		return () => window.removeEventListener('resize', updateComputerFontSizes)
	}, [typeHelperOn])

	if (!typeHelperOn) return null

	return (
		<div className="fixed z-[999999] inset-0 p-4 sm:p-6 md:p-8 pointer-events-none bg-white/90 dark:bg-black/90">
			<h2 className="mb-4">Window size: {windowWidth}px</h2>
			<div className="text-xs mb-4 leading-100">text-xs: <span className="show-computed-size"></span></div>
			<div className="text-sm mb-4 leading-100">text-sm: <span className="show-computed-size"></span></div>
			<div className="text-base mb-4 leading-100">text-base: <span className="show-computed-size"></span></div>
			<div className="text-lg mb-4 leading-100">text-lg: <span className="show-computed-size"></span></div>
			<div className="text-xl mb-4 leading-100">text-xl: <span className="show-computed-size"></span></div>
			<div className="text-2xl mb-4 leading-100">text-2xl: <span className="show-computed-size"></span></div>
			<div className="text-3xl mb-4 leading-100">text-3xl: <span className="show-computed-size"></span></div>
			<div className="text-4xl mb-4 leading-100">text-4xl: <span className="show-computed-size"></span></div>
			<div className="text-5xl mb-4 leading-100">text-5xl: <span className="show-computed-size"></span></div>
			<div className="text-6xl mb-4 leading-100">text-6xl: <span className="show-computed-size"></span></div>
			<div className="text-7xl mb-4 leading-100">text-7xl: <span className="show-computed-size"></span></div>
		</div>
	)
}
